import type { Activity } from '@/core/types/activity';
import type { Account, Contact } from '@/core/types/crm';
import type { Opportunity } from '@/core/types/sales';
import type { LeadStatusHistory } from '@/core/types/lead';

const key = 'crm-demo-modules-v1';
interface State { contacts: Contact[]; accounts: Account[]; opportunities: Opportunity[]; activities: Activity[]; leadHistory: Record<string, LeadStatusHistory[]> }
const empty = (): State => ({ contacts: [], accounts: [], opportunities: [], activities: [], leadHistory: {} });
export const moduleMockStore = {
  get(): State { try { return { ...empty(), ...(JSON.parse(localStorage.getItem(key) || '') as State) }; } catch { return empty(); } },
  save(state: State): void { localStorage.setItem(key, JSON.stringify(state)); },
  reset(): void { localStorage.removeItem(key); },
};
